import { LogicalFieldMixin } from './mixins.js';

const LogicalMember = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <div class="form-field-value input-control right-addon grow-input">
        <div class="controlled-input placeholder">请选择</div>
        <span class="addon">
          <i class="slp-caret-down"></i>
        </span>
      </div>
    </div>
  `
};

export default LogicalMember;
